export default __webpack_public_path__ + "static/media/AboutBg1.8589b6b7.png";